import {Component} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import BranchForm from "../../mixins/BranchForm";

const template = `
  <div class="pp pp--blue">
    <div class="pp__close menu__sndw  menu__sndw--active" @click="$emit('close')"></div>
    <div class="pp__title pp__title--v2">
      Мы готовы ответить на любые интересующие вас вопросы или принять предложение об участии в тендере
    </div>
      <div class="pp__form form form--th3">
          <div class="form__ctrl ">
              <input
                      type="text" placeholder="Ваше имя*" class="form__input"
                      v-model="form.data.name"
                      :class="{'form__input--error': form.errors.has('name')}"
              >
          </div>
          <div class="form__ctrl ">
              <input
                      v-mask="'+7 (###) ###-##-##'"
                      type="text" placeholder="Телефон*" class="form__input"
                      v-model="form.data.phone"
                      :class="{'form__input--error': form.errors.has('phone')}"
              >
          </div>
          <div class="form__ctrl">
          <textarea
                  type="text" placeholder="Сообщение" class="form__textarea"
                  v-model="form.data.message"
                  :class="{'form__input--error': form.errors.has('message')}"
          ></textarea>
          </div>
          <div class="form__ctrl">
              <form-file
                      mimes="application/pdf, application/msword"
                      :file.sync="fileTZ"
                      label="Прикрепить тз (до 10MB)"
              ></form-file>
          </div>
          <div class="form__ctrl">
              <label
                      class="checkbox checkbox--th1"
                      :class="{'checkbox--error': form.errors.has('agreement')}"
              >
                  <input type="checkbox" v-model="form.data.agreement">
                  <span>
                      <sup>
                        Согласие на обработку <a href="#" @click.stop.prevent="openAgreement">персональных данных</a>
                      </sup>
                    </span>
              </label>
          </div>
          <div class="form__ctrl" @click="send">
              <div class="branch__form-btn">
                  Отправить
              </div>
          </div>
      </div>
  </div>
`;

@Component({
  template: template,
})
export default class FormRequestBranch extends mixins(BranchForm) {

  async mounted() {
    this._token = document.querySelector<HTMLElement>('#token')?.innerText || '';
  }
}
